import "zone.js";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { App } from "./app/app";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}

declare const module: any;

if (module["hot"]) {
  module["hot"].accept();
  module["hot"].dispose(() => {
    const appRoot = document.querySelector("app-root");
    if (appRoot) {
      appRoot.innerHTML = ""; // clear old instance
    }
  });
  bootstrap();
} else {
  bootstrap();
}
